var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "xl",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function (ref) {
            var close = ref.close
            return [_c("div", { staticClass: "modal-footer" })]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_user_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _c("h2", [_c("span", { staticClass: "fw-300" })]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-container show" },
            [
              _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
                _c("div", { staticClass: "panel-container show" }, [
                  _c("div", { staticClass: "panel-content mb-0" }, [
                    _c("div", { staticClass: "user_auth" }, [
                      _c(
                        "form",
                        { staticClass: "user", attrs: { autocomplete: "off" } },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label",
                                  attrs: {
                                    for: "input-live-feedback_username",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.__t("YANDEX_CLIENT_ID")) +
                                      "\n                                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "form-control form-control-use",
                                attrs: {
                                  disabled: true,
                                  id: "input-live-feedback_username",
                                  placeholder: "Логин",
                                },
                                model: {
                                  value: _vm.user_form.client_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user_form, "client_id", $$v)
                                  },
                                  expression: "user_form.client_id",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group mt-3" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label",
                                  attrs: {
                                    for: "input-live-feedback_username",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.__t("YANDEX_CLIENT_SECRET")) +
                                      "\n                                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "form-control form-control-user",
                                attrs: {
                                  disabled: true,
                                  id: "user_pass_register",
                                  placeholder: "Пароль",
                                },
                                model: {
                                  value: _vm.user_form.client_secret,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.user_form,
                                      "client_secret",
                                      $$v
                                    )
                                  },
                                  expression: "user_form.client_secret",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }